// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","736":"vendor"}[chunkId] + "." + {"532":"54c51afce296f864334a","736":"8d75ae20a1102fa7c7d9"}[chunkId] + ".css";
};